// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M9 3.5H13.5M9 8H13.5M9 12.5H13.5',
  'M3 4.1L4.15 3.5V6.8',
  'M3 9.65C3.32 9.13 3.75 8.95 4.25 8.95C4.98 8.95 5.55 9.4 5.55 10.05C5.55 10.45 5.25 10.8 4.85 11.1L3 12.5H5.65',
];
